import { render, staticRenderFns } from "./Leitos.vue?vue&type=template&id=c1cf6bf8&"
import script from "./Leitos.vue?vue&type=script&lang=js&"
export * from "./Leitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports